var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Field__Component", class: { [_vm.align]: _vm.align } },
    [_c("div", [_vm._v(_vm._s(_vm.date))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }